"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon
 * (C) Copyright IBM Corp. 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 *
 */
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
const react_1 = tslib_1.__importStar(require("react"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const carbon_components_react_1 = require("carbon-components-react");
const settings_1 = tslib_1.__importDefault(require("../settings"));
const { prefix } = settings_1.default;
class ToggleSmall extends react_1.Component {
    constructor() {
        super(...arguments);
        this._ref = node => {
            this._node = node;
        };
    }
    focus() {
        this._node.focus();
    }
    render() {
        const _a = this.props, { className } = _a, others = tslib_1.__rest(_a, ["className"]);
        const clsName = classnames_1.default(className, { 'ba-ui-carbon-toggle': this.props.light });
        return (react_1.default.createElement(carbon_components_react_1.ToggleSmall, Object.assign({ "data-tid": `${prefix}-toggle-small`, className: clsName, ref: this._ref }, others)));
    }
}
exports.default = ToggleSmall;
ToggleSmall.propTypes = Object.assign(Object.assign({}, carbon_components_react_1.ToggleSmall.propTypes), { 
    // light variant to workaround https://jsw.ibm.com/browse/BAUICOMMON-218
    light: prop_types_1.default.bool });
ToggleSmall.defaultProps = Object.assign(Object.assign({}, carbon_components_react_1.ToggleSmall.defaultProps), { light: false });
